import { Modal } from 'bootstrap'
import {Spinner } from './loandig'
import Swal from 'sweetalert2'
import axios from 'axios';

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css'

const resetFormAfterSuccess = (form) => {
  if (!form) return;
  form.reset();

  const tourSelect = form.querySelector('#tourSelect');
  const uuidInput = form.querySelector('#tourUuid');
  if (tourSelect && uuidInput) {
    const currentOption = tourSelect.options[tourSelect.selectedIndex];
    uuidInput.value = currentOption ? (currentOption.getAttribute('data-uuid') || '') : '';
  }
};

// has inquiry
const openModal= document.querySelector('.inquery');
if(openModal){
    const myModal = new Modal(document.getElementById('staticBackdrop'))
    openModal.addEventListener('click',(e)=>{
           myModal.show();
    })
}


// / CONTACT FORM NEW SCRIPT PAGE
const fromContact = document.getElementById('contact_form');

if (fromContact) {
    const urls = fromContact.getAttribute('data-action');
    fromContact.addEventListener('submit', async (e) => {
        e.preventDefault();
        const load = new Spinner({
            selector: ".loandig",
            width: 25,
            height: 25,
            text: "loandig..",
            color: "#d7b672",
            background: "#fff",
        });
        load.active();
        try {
            const peardata = new FormData(fromContact);
            peardata.append('type', 'contact');
            const response = await axios.post(urls, peardata);
            if (response.status === 200) {
                const data = response.data;
                if (data.status === 200) {
                    load.hide();
                    resetFormAfterSuccess(fromContact);
                    Swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: "success",
                        showCancelButton: false,
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                } else if (data.status === 500) {
                    load.hide();
                    Swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: "error",
                        showCancelButton: false,
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                } else {
                    load.hide();
                    fromContact.reset();
                    const result = await Swal.fire({
                        title: data,
                        text: null,
                        icon: "error",
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'Update',
                        showCloseButton: true,
                        confirmButtonColor: '#000',
                        customClass: {
                            confirmButton: 'btn-sm rounded-0 shadow-0'
                        }
                    });
                    if (result.isConfirmed) {
                        location.reload();
                    }
                }
            } else {
                load.hide();
                throw new Error('The request was not successful');
            }
        } catch (error) {
            load.hide();
            console.log(error);
            Swal.fire({
                title: 'Error',
                text: 'An unexpected error occurred. Please try again later.',
                icon: 'error',
            });
        }
    });
}



//  BOOKING FORM SCRIPRT
 const booking=document.querySelector('#formbook');
 const loads = new Spinner({
  selector: ".loandigs",
  width: 25,
  height: 25,
  text: "loandig..",
  color: "#d7b672",
  background: "#fff",
});
 if(booking){
  const url=booking.getAttribute('data-action');
  booking.addEventListener('submit',(e)=>{
     e.preventDefault()
     loads.active()
   const peardatabook = new FormData(booking);
   peardatabook.append('type','booking');    
   // peardata.append('action', PEARSCRIPTC.action_contact);

   fetch(url, { method: 'POST', body: peardatabook })
   .then(response => {
       if (response.ok) {
           return response.json();
       } else {
        loads.hide()
           throw new Error('The request was not successful');
       }
   })
   .then(data => {
       console.log(data)
       if(data.status===200) {
        loads.hide()
        resetFormAfterSuccess(booking);
        Swal.fire({
          title: data.title,
          text:  data.message,
          icon: "success",
          showCancelButton: false,
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
        //   html: `<a href="${data.payLink}" class="btn btn-primary rounded-0 text-white ">Continue with payment</a>`
        });
        
       }else if(data.status==500) {
        loads.hide()
         Swal.fire({
           title: data.title,
           text:  data.message,
           icon: "error",
           showCancelButton: false,
           showConfirmButton:false,
           showCloseButton: true,
         });
       }else{
        loads.hide()
        //  booking.reset()
         Swal.fire({
           title: data,
           text: null,
           icon: "error",
           showCancelButton: false,
           showConfirmButton: true,
           confirmButtonText: 'Update',
           showCloseButton: true,
           confirmButtonColor: '#000', // Cambia esto al color que desees
           customClass: {
             confirmButton: ' btn-sm rounded-0 shadow-0' // Agrega aquí la clase personalizada que quieras
           }
         }).then((result) => {
           if (result.isConfirmed) {
             location.reload(); // Esto recarga la página
           }
         });
                
       }        
   })
   .catch(error => {
    loads.hide()
       console.error( error);  
       Swal.fire({
           title: 'Error',
           text: 'An unexpected error occurred. Please try again later.',
           icon: 'error',
         });    

   });
  })
 }

const lightbox = GLightbox({
    selector:'.glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
const lightbox1 = GLightbox({
  selector:'.glightbox1',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});
const lightbox2 = GLightbox({
  selector:'.glightbox2',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});
const lightbox3 = GLightbox({
  selector:'.glightbox3',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});

const lightboxvideo = GLightbox({
  selector:'.glightboxVideo',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});
const lightboxvideo1 = GLightbox({
  selector:'.glightboxVideo1',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});

// Tour gallery — hero images in single-tour.php
const lightboxTourGallery = GLightbox({
  selector: '.glightbox[data-gallery="tour-gallery"]',
  touchNavigation: true,
  loop: true,
  autoplayVideos: false
});

// *************tabs*************

  // var contens=document.querySelector('')
  // var sections = document.querySelectorAll('.secciont-tab');
  // var menuItems = document.querySelectorAll('.TabLink');

//   window.addEventListener('scroll', function() {
//     var sections = document.querySelectorAll('.secciont-tab');
//     var navLinks = document.querySelectorAll('.TabLink');

//     sections.forEach(function(section, index) {
//         var top = section.offsetTop;
//         var height = section.offsetHeight;

//         if (window.scrollY >= top && window.scrollY < top + height) {
//             navLinks.forEach(function(navLink) {
//                 navLink.classList.remove('active');
//             });

//             if (navLinks[index]) {
//                 navLinks[index].classList.add('active');
//             }
//         }
//     });
// });

  

window.addEventListener('load', () => {
  const getAll = (query, Root = document) => Root.querySelectorAll(query);

  const links = document.querySelectorAll('.TabLink');
  const sections = document.querySelectorAll('.secciont-tab');
  const menuheight = document.querySelector('#menu').clientHeight;

  const makeNavLinksSmooth = () => {
    const navLinks = document.querySelectorAll(".TabLink");
    navLinks.forEach((link, index) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetSection = document.querySelector(link.hash);
        if (targetSection) {
          sections.forEach((section, idx) => {
            section.style.paddingTop = (idx === index) ? '1em' : '0'; // Reset padding for non-active sections
          });
          targetSection.style.paddingTop = "1em";
          targetSection.scrollIntoView({
            behavior: "smooth"
          });
        }
      });
    });
  };

  const spyScrolling = () => {
    window.onscroll = () => {
      const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
      sections.forEach((section, index) => {
        if (section.offsetTop <= scrollPos && (index === sections.length - 1 || sections[index + 1].offsetTop > scrollPos)) {
          const id = section.id;
          section.style.paddingTop = '1em';
          const activeLink = document.querySelector(".TabLink.active");
          if (activeLink) activeLink.classList.remove("active");
          const correspondingLink = document.querySelector(`a[href="#${id}"]`);
          if (correspondingLink) correspondingLink.classList.add("active");
        } else {
          section.style.paddingTop = '0';
        }
      });
    };
  };

  makeNavLinksSmooth();
  spyScrolling();
});
